/** API list item: { tom: <internal id>, secondaryId: <display id>, ... } */
export const getTomId = (item) => item?.tom ?? item?.id;

export const getTomDisplayId = (item) =>
    item?.secondaryId ?? item?.secondary_id;
